<nwm-menu />
<div class="main content">
  <div class="row no-gutters py-4">
    <div class="col-xxl-10 offset-xxl-1">
      <h1 class="mt-4">Net Amount Invested and Cumulative Profit As Of {{ valuationDate | date:'MMMM d, yyyy'}}</h1>
      <div class="card chart-block">
        <div class="card-body p-3" style="overflow: auto">
          <div style="min-width:600px">
            <p class="card-text">
              <span><i class="fa fa-circle" aria-hidden="true" style="color: #1D3A6A"></i>&nbsp;Net Amount Invested</span>&nbsp;&nbsp;
              <span><i class="fa fa-circle" aria-hidden="true" style="color: #88A8A3"></i>&nbsp;Profit</span>
            </p>
            <AICFChart [plan]="plan" />
          </div>
        </div>
      </div>
      @if (plan==='' && !isPershing) {
        <span style="font-size: smaller;" class="pull-right">*All values are in CAD</span>
      }
      @if (isPershing) {
        <span style="font-size: smaller;" class="pull-right">*All values are in USD</span>
      }
      <br />
      <h1 class="mt-4">Historic Portfolio Performance As Of {{ valuationDate | date:'MMMM d, yyyy'}}</h1>
      @if (data.length > 0) {
        <div class="scrollable-wrap">
          <div class="scrollable">
            <div class="scrollable-button left"></div>
            <div class="scrollable-button"></div>
            <table width="100%" class="NWMtable sticky_header table-hover">
              <thead>
                <tr class="section-header">
                  <th class="td-period" style="text-align: left">Period Ending</th>
                  <th class="td-currency text-center">Currency</th>
                  <th class="td-mv" align="right">Market Value&nbsp;($)</th>
                  <th class="td-ai" align="right">Net Amount Invested<br />During Year&nbsp;($)</th>
                  <th class="td-tai" align="right">Net Amount Invested<br />Since Inception&nbsp;($)</th>
                  <th class="td-psi" align="right">Profit<br />Since Inception&nbsp;($)</th>
                  <th class="td-arsi" align="right">Annualized Return<br />Since Inception</th>
                  <th class="td-cytdr" align="right">Calendar YTD<br />Return</th>
                </tr>
              </thead>
              <tbody>
                @for (item of data; track item) {
                  @for (item2 of item.Details; track item2; let i = $index) {
                    <tr>
                      @if (i===0) {
                        <td class="td-period" [attr.rowspan]="item.Details.length">{{item.Details[0].PeriodEnding | date}}</td>
                      }
                      <td class="td-currency text-center" style="text-align: left">{{item2.Currency}}</td>
                      <td class="td-mv" align="right">{{item2.MarketValue | placeholder:'-'}}</td>
                      <td class="td-ai" align="right">{{item2.InvestedDuringYear | placeholder:'-'}}</td>
                      <td class="td-tai" align="right">{{item2.InvestedSinceInception | placeholder:'-'}}</td>
                      <td class="td-psi" align="right">{{item2.ProfitSinceInception | placeholder:'-'}}</td>
                      <td class="td-arsi" align="right">{{item2.ReturnSinceInception}}</td>
                      <td class="td-cytdr" align="right">{{item2.ReturnForYear}}</td>
                    </tr>
                  }
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>